import React from "react";

const ProjectorLogo = ({ size }) => {
  if (!size || size === "") {
    size = "14px";
  }
  return (
    <div style={{ width: size, height: size }}>
      <img
        style={{ width: size, height: size }}
        src={"/images/projector_logo.png"}
        alt="Projector Logo"
      />
    </div>
  );
};

export default ProjectorLogo;
